import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { throwError } from "rxjs";
import { catchError, finalize, first, tap } from "rxjs/operators";

import { DffError, isNumeric } from "@dffedb/util";
import { LoginService } from "@e-forsyning/common/auth";

import { LoginData } from "../login-data.model";
import { LoginHjaelpService } from "../login-hjaelp/login-hjaelp.service";
import { MatomoTracker } from "ngx-matomo-client";

@Component({
    selector: "login-forbrugernr",
    templateUrl: "./login-forbrugernr.component.html"
})
export class LoginForbrugernrComponent {
    @Input()
    public parent: UntypedFormGroup;

    @Output()
    public loginSucceeded = new EventEmitter<any>();

    @Output()
    public alphaKeyPressed = new EventEmitter<string>();

    @ViewChild("forbrugerNrInput", { static: true }) public forbrugerNrInput: ElementRef;

    public arbejder = false;
    public fejlBesked = "";

    constructor(
        private readonly loginService: LoginService,
        private readonly loginHjaelpService: LoginHjaelpService,
        private matomoTracker: MatomoTracker
    ) {}

    public focus(): void {
        this.forbrugerNrInput.nativeElement.focus();
    }

    public loginClick(): void {
        const loginData: LoginData = {
            brugernavn: this.parent.get("forbrugerNrGroup.forbrugerNr").value,
            kodeord: this.parent.get("forbrugerNrGroup.kode").value,
            huskMig: this.parent.get("huskMig").value
        };
        this.onForbrugerLogin(loginData);
    }

    public onForbrugerLogin(credentials: LoginData): void {
        this.fejlBesked = "";
        this.arbejder = true;
        this.loginService
            .login(credentials.brugernavn, credentials.kodeord, credentials.huskMig)
            .pipe(
                first(),
                tap((result) => {
                    if (result.success) {
                        this.matomoTracker.trackEvent("Authentication", "Login Success", "Forbrugernummer");
                        this.loginSucceeded.emit();
                    } else {
                        this.matomoTracker.trackEvent("Authentication", "Login Failed", "Forbrugernummer - Invalid Credentials");
                        this.fejlBesked = "Ugyldig forbrugernummer eller kode";
                    }
                }),
                catchError((error: DffError) => {
                    this.matomoTracker.trackEvent("Authentication", "Login Failed", "Forbrugernummer - Error");
                    this.fejlBesked = error.friendlyMessage || error.message;
                    return throwError(error);
                }),
                finalize(() => {
                    this.arbejder = false;
                })
            )
            .subscribe();
    }

    public loginHjaelpClick(): void {
        this.loginHjaelpService.visLoginHjaelpDialog();
    }

    public onForbrugernummerKeypress(event: KeyboardEvent): void {
        const feltetErBlankt = !this.parent.get("forbrugerNrGroup.forbrugerNr").value;
        if (feltetErBlankt && !isNumeric(event.key)) {
            this.alphaKeyPressed.emit(event.key);
        }
    }
}
